function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.826 11.974l-.852.851a.6.6 0 01-.846 0L4 5.71a2.286 2.286 0 01-.6.09 2.4 2.4 0 01-2.268-3.18l1.524 1.524.318-.318.852-.852.318-.318L2.62 1.132A2.4 2.4 0 015.8 3.4a2.286 2.286 0 01-.09.6l7.116 7.128a.6.6 0 010 .846zm-11.652-.846a.6.6 0 000 .846l.852.851a.6.6 0 00.846 0L6.154 9.55 4.456 7.852M11.8 1L9.4 2.2v1.2L8.098 4.702l1.2 1.2L10.6 4.6h1.2L13 2.2 11.8 1z",
  fill: "currentColor"
});

var SvgService = function SvgService(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _ref);
};

export default SvgService;